import { UserAuthority } from './user-authority';

/**
 * Authenticated User.
 *
 * @author Warlock, AIS.PL
 */
export class AuthenticatedUser {

  readonly authorities: UserAuthority[];

  readonly id: number;

  readonly dealerId: number;

  readonly username: string;

  /**
   * Returns newly created user with properties defined by its JSON representation.
   *
   * @param jsonObject JSON object holding user properties
   */
  static fromJSON(jsonObject: any): AuthenticatedUser {
    const authorities: UserAuthority[] = (jsonObject.authorities
      ? Array.from(jsonObject.authorities, authority => UserAuthority.fromString(<string>authority))
      : <UserAuthority[]> []);
    const id = jsonObject.id ? Number(jsonObject.id) : null;
    const dealerId = jsonObject.dealerId ? Number(jsonObject.dealerId) : null;

    const result = Object.create(AuthenticatedUser.prototype);
    return Object.assign(result, {
      authorities, id, dealerId, username: jsonObject.username
    });
  }

  /**
   * Verifies if the user has any of the given authorities.
   *
   * @param first first authority to check
   * @param rest the rest of authorities to check
   */
  public hasAuthority(first: UserAuthority, ...rest: UserAuthority[]): boolean {
    const expected: UserAuthority[] = Array.from(rest);
    expected.unshift(first);
    return this.hasAnyOfAuthorities(expected);
  }

  /**
   * Verifies if the user has any of the given authorities.
   *
   * @param authorities authorities to check
   */
  public hasAnyOfAuthorities(authorities: UserAuthority[]) {
    return 0 < this.authorities.filter(authority => -1 !== authorities.indexOf(authority)).length;
  }

  /**
   * Converts the user to its JSON representation.
   */
  public toJSON(): any {
    return Object.assign({}, {
      authorities: this.authorities.map(authority => UserAuthority[authority]),
      id: this.id,
      dealerId: this.dealerId,
      username: this.username
    });
  }

}
